import React from 'react'
import { Link } from 'react-router-dom'
import Seo from '../components/seo/Seo'
import { useBreadcrumbs } from '../seo/useBreadcrumbs'

const Sitemap: React.FC = () => {
  const crumbs = useBreadcrumbs([{ label: 'Sitemap', path: '/sitemap' }], 'light')
  return (
    <div className="bg-sand min-h-screen py-24">
      <Seo
        title="Sitemap | Merritt & Shawn | Coastal Delaware Real Estate — Delaware Beaches"
        description="Every page on debeachrealestate.com — Delaware beach homes for sale, town guides for Lewes, Rehoboth, Dewey, Bethany, Fenwick Island & Milton, and how to reach us."
        path="/sitemap"
        jsonLd={[crumbs.jsonLd]}
      />
      <div className="max-w-3xl mx-auto px-6">
        {crumbs.node}
        <p className="font-display text-[12px] uppercase tracking-[0.3em] font-bold text-accent-gold mb-4">
          Navigation
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-primary-ink tracking-tight mb-10">
          Sitemap
        </h1>
        <div className="space-y-8 font-sans text-neutral-charcoal">
          <div>
            <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide mb-3">
              Areas We Serve
            </h2>
            <ul className="space-y-2">
              <li><Link to="/areas" className="text-accent-gold hover:underline">All Towns & Communities</Link></li>
              <li><Link to="/areas/lewes" className="text-accent-gold hover:underline">Lewes Real Estate</Link></li>
              <li><Link to="/areas/rehoboth-beach" className="text-accent-gold hover:underline">Rehoboth Beach Real Estate</Link></li>
              <li><Link to="/areas/dewey-beach" className="text-accent-gold hover:underline">Dewey Beach Real Estate</Link></li>
              <li><Link to="/areas/bethany-beach" className="text-accent-gold hover:underline">Bethany Beach Real Estate</Link></li>
              <li><Link to="/areas/fenwick-island" className="text-accent-gold hover:underline">Fenwick Island Real Estate</Link></li>
              <li><Link to="/areas/milton" className="text-accent-gold hover:underline">Milton Real Estate</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide mb-3">
              Buy & Sell
            </h2>
            <ul className="space-y-2">
              <li><Link to="/listings" className="text-accent-gold hover:underline">Live Listings Map</Link></li>
              <li><Link to="/buy" className="text-accent-gold hover:underline">Buy a Home at the Delaware Beaches</Link></li>
              <li><Link to="/sell" className="text-accent-gold hover:underline">Sell Your Delaware Beach Home</Link></li>
              <li><Link to="/faq" className="text-accent-gold hover:underline">Delaware Beach Real Estate FAQs</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide mb-3">
              Company
            </h2>
            <ul className="space-y-2">
              <li><Link to="/" className="text-accent-gold hover:underline">Home</Link></li>
              <li><Link to="/about" className="text-accent-gold hover:underline">About Us</Link></li>
              <li><Link to="/contact" className="text-accent-gold hover:underline">Contact Us</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide mb-3">
              Legal
            </h2>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-accent-gold hover:underline">Privacy Policy</Link></li>
              <li><Link to="/accessibility" className="text-accent-gold hover:underline">Accessibility</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-primary-ink uppercase tracking-wide mb-3">
              Home Sections
            </h2>
            <ul className="space-y-2">
              <li><a href="/#listings" className="text-accent-gold hover:underline">Listings</a></li>
              <li><a href="/#neighborhoods" className="text-accent-gold hover:underline">Beach Towns</a></li>
              <li><a href="/#testimonials" className="text-accent-gold hover:underline">Testimonials</a></li>
              <li><a href="/#sold-highlights" className="text-accent-gold hover:underline">Sold Highlights</a></li>
              <li><a href="/#community" className="text-accent-gold hover:underline">Community</a></li>
              <li><a href="/#about" className="text-accent-gold hover:underline">About</a></li>
              <li><a href="/#contact" className="text-accent-gold hover:underline">Contact</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sitemap
